import { RootState } from 'src/types';

export const quoteDetailSelector = (state: RootState) => state.quoteDetail.quoteDetail;